import { useEffect, useState } from 'react';
import { Auth, Implementation } from '@leagueplatform/auth';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';

declare module '@auth0/auth0-spa-js' {
  interface IdToken {
    'https://el/impersonation_type'?: 'caregiver' | 'agent';
    'https://el/act_as'?: {
      sub: string;
    };
  }
}

/**
 * @deprecated use `getImpersonationType` instead.
 */
export const getIsImpersonator = async () => {
  if (Auth.initialized && Auth.implementation === Implementation.STANDALONE) {
    const claims = await StandaloneAuth.client.getIdTokenClaims();
    const isImpersonator = claims?.['https://el/act_as']?.sub;
    const impersonationType = claims?.['https://el/impersonation_type'];

    if (impersonationType && impersonationType === 'agent') {
      return true;
    }
    if (!impersonationType && isImpersonator) {
      return true;
    }
    return false;
  }
  return null;
};

export const useGetIsImpersonator = () => {
  const [isImpersonator, setIsImpersonator] = useState<boolean | null>(null);

  useEffect(() => {
    const checkImpersonation = async () => {
      const result = await getIsImpersonator();
      setIsImpersonator(result);
    };

    checkImpersonation();
  }, []);

  return isImpersonator;
};

export const getImpersonationType = async () => {
  if (Auth.initialized && Auth.implementation === Implementation.STANDALONE) {
    const claims = await StandaloneAuth.client.getIdTokenClaims();
    const isImpersonator = Boolean(claims?.['https://el/act_as']?.sub);
    const impersonationType = claims?.['https://el/impersonation_type'];

    if (isImpersonator) {
      return impersonationType ?? 'agent';
    }
    return false;
  }
  return null;
};

export type ImpersonationType = Awaited<
  ReturnType<typeof getImpersonationType>
>;
export const useGetImpersonationType = () => {
  const [impersonationType, setImpersonationType] =
    useState<ImpersonationType>(null);

  useEffect(() => {
    const checkImpersonationType = async () => {
      const impersonationTypeResult = await getImpersonationType();
      setImpersonationType(impersonationTypeResult);
    };

    checkImpersonationType();
  }, []);

  return impersonationType;
};
